import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';

import { HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { catchError, of } from 'rxjs';
import { DunaReportWizardComponent } from '../duna-report-wizard/duna-report-wizard.component';
import { ReportWizardContext } from '../duna-report-wizard/report-wizard-context';
import { createDefaultReportConfig } from '../../../dto/advi/advi.dto';
import { createDefaultListRequest } from '../../../dto/list-request.dto';
import { ComponentDataSourceService } from '../../../services/component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';

@Component({
  selector: 'app-duna-report-generator',
  templateUrl: './duna-report-generator.component.html',
  styleUrls: ['./duna-report-generator.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, MatIconModule, DunaReportWizardComponent],
})
export class DunaReportGeneratorComponent implements OnInit {
  showWizard = false;
  reportJustGenerated = false;
  wizardContext: ReportWizardContext = { mode: 'station' };
  locationGuid = '';
  locationName = '';
  missingLocation = false;

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private dataSource: ComponentDataSourceService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.extractLocationFromUrl();
    if (this.locationGuid) {
      this.resolveLocationNameThenOpen();
    } else {
      this.missingLocation = true;
    }
  }

  /** Kan stadig kaldes fra CMS-knap */
  openModal(): void {
    if (!this.locationGuid) {
      this.extractLocationFromUrl();
    }
    if (!this.locationGuid) {
      this.missingLocation = true;
      return;
    }
    this.resolveLocationNameThenOpen();
  }

  private resolveLocationNameThenOpen(): void {
    // Prefer direct location lookup (works for uddansvarlig after API role fix)
    this.http
      .get<any>(`${environment.apiUrl}/locations/${this.locationGuid}`)
      .pipe(catchError(() => of(null)))
      .subscribe((direct) => {
        const fromDirect =
          direct?.locations_name ||
          direct?.data?.locations_name ||
          direct?.name;
        if (fromDirect) {
          this.locationName = fromDirect;
          this.openWizard();
          return;
        }

        const req = createDefaultListRequest();
        req.pageSize = 10000;
        const call = this.dataSource.executeDataSource('locations', {
          listRequest: req,
        });
        if (!call) {
          this.openWizard();
          return;
        }
        call.subscribe({
          next: (r: any) => {
            const items = r?.items || r?.data || [];
            const match = items.find((l: any) => l.guid === this.locationGuid);
            this.locationName = match?.locations_name || match?.name || '';
            this.openWizard();
          },
          error: () => this.openWizard(),
        });
      });
  }

  private openWizard(): void {
    this.missingLocation = false;
    this.reportJustGenerated = false;
    this.wizardContext = {
      mode: 'station',
      locationGuid: this.locationGuid,
      locationName: this.locationName,
      initialConfig: {
        ...createDefaultReportConfig('event_report'),
        location_guids: [this.locationGuid],
        delivery: {
          ...createDefaultReportConfig().delivery,
          advisering_enabled: false,
        },
      },
    };
    this.showWizard = true;
    this.cdr.detectChanges();
  }

  onWizardCancelled(): void {
    this.showWizard = false;
    this.reportJustGenerated = false;
  }

  onWizardGenerated(): void {
    this.showWizard = false;
    this.reportJustGenerated = true;
  }

  private extractLocationFromUrl(): void {
    const path = this.router.url;
    const guidMatch = path.match(/\/lokation\/([a-f0-9-]+)/i);
    if (guidMatch?.[1]) {
      this.locationGuid = guidMatch[1];
    } else {
      const segments = path.split('/');
      const idx = segments.indexOf('lokation');
      if (idx >= 0 && segments[idx + 1]) {
        this.locationGuid = segments[idx + 1].split('?')[0];
      }
    }
  }
}
